//@service
import {bind,RepositoryInterface} from '@/service/utils'
export const profileService= {
  get profileRepository() {
    return bind(() => import('./profile.repo'), RepositoryInterface);
  },
  get personRelationRepository() {
    return bind(() => import('./personRelation.repo'), RepositoryInterface);
  },
  get mobileRepository() {
    return bind(() => import('./mobile.repo'), RepositoryInterface);
  },
  get allAttachmentRepository() {
    return bind(() => import('./allAttachment.repo'), RepositoryInterface);
  },
  get personSocialExperienceRepository() {
    return bind(() => import('./personSocialExperience.repo'), RepositoryInterface);
  },
  get personEducationRepository() {
    return bind(() => import('./personEducation.repo'), RepositoryInterface);
  },
  get locationRepository() {
    return bind(() => import('./location.repo'), RepositoryInterface);
  },
  get personJobExperienceRepository() {
    return bind(() => import('./personJobExperience.repo'), RepositoryInterface);
  },
  get personLicenseRepository() {
    return bind(() => import('./personLicense.repo'), RepositoryInterface);
  },
  get personAddressRepository() {
    return bind(() => import('./personAddress.repo'), RepositoryInterface);
  },
  get personArticleRepository() {
    return bind(() => import('./personArticle.repo'), RepositoryInterface);
  },
  get personStateRepository() {
    return bind(() => import('./personState.repo'), RepositoryInterface);
  },
  get attachmentTempFinalRepository() {
    return bind(() => import('./attachmentTempFinal.repo'), RepositoryInterface);
  },
  get personResearchInterviewRepository() {
    return bind(() => import('./personResearchInterview.repo'), RepositoryInterface);
  },
  get personSkillRepository() {
    return bind(() => import('./personSkill.repo'), RepositoryInterface);
  },
  get permissionGroupResourceRepository() {
    return bind(() => import('./permissionGroupResource.repo'), RepositoryInterface);
  },
  get personRelationCodeRepository() {
    return bind(() => import('./personRelationCode.repo'), RepositoryInterface);
  },
  get educationPersonRepository() {
    return bind(() => import('./educationPerson.repo'), RepositoryInterface);
  },
  get personFamilyRelationRepository() {
    return bind(() => import('./personFamilyRelation.repo'), RepositoryInterface);
  },
  get personWifeRelationRepository() {
    return bind(() => import('./personWifeRelation.repo'), RepositoryInterface);
  },
  get personFreeCourseRepository() {
    return bind(() => import('./personFreeCourse.repo'), RepositoryInterface);
  },
  get personHasDataRepository() {
    return bind(() => import('./personHasData.repo'), RepositoryInterface);
  },
  get personRepository() {
    return bind(() => import('./person.repo'), RepositoryInterface);
  },
  get personExportPdfRepository() {
    return bind(() => import('./personExportPdf'), RepositoryInterface);
  },
  get hozehGhazayiRepository() {
    return bind(() => import('./hozehGhazayi.repo'), RepositoryInterface);
  },
  get personIdentityRepository() {
    return bind(() => import('./personIdentity.repo'), RepositoryInterface);
  },
  get reportAccessRepository() {
    return bind(() => import('./reportAccess.repo'), RepositoryInterface);
  },
}

